import * as React from 'react';
import { QuickSearchInput } from './QuickSearchInput';
export const QuickSearchViewPanelControl = (props) => {
    let elementType = props.viewType === 'ToolPanel' ? 'DashboardToolbar' : 'ToolPanel';
    return React.createElement(QuickSearchInput, { className: `ab-${elementType}__QuickSearch__text`, width: '15rem' });
};
